// extracted by mini-css-extract-plugin
export default {"emptyResult":"SearchResult__emptyResult___X2Rga","searchListContainer":"SearchResult__searchListContainer___AuOzH","skeleton-loading":"SearchResult__skeleton-loading___AvSO8"};